export const CloudStatus = {
  NoIssue: 1,
  FirstReportOfIssue: 2,
  UnknownIssue: 3,
  DnsError: 4,
  IntermediaIssue: 5,
  OperationalButNotFully: 6,
  IterationUpdate: 7,
  SilentUpdate: 8,
  Custom: 9
}

export const CloudStatusIconColor = {
  Green: 1,
  Red: 2,
  Orange: 3,
  Blue: 4

}

export default CloudStatus;